export default __webpack_public_path__ + "static/media/dash-indeed.c942a3cc.svg";